// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"R6-z","sponsoredTooltipWrapper":"S6-z","sponsoredTooltip":"T6-z","newCard":"U6-z"};